export const incomeCategories = [
  ['Community', 'Government Departments and Agencies'],
  ['Transfer', 'Payroll'],
];
